module.exports = __webpack_public_path__ + "static/media/filterNew.978fd2e2.svg";